import React from 'react';
import {hot} from 'react-hot-loader';
import {Provider} from 'react-redux';
import GiftCardRedemptionContainer from './components/GiftCardRedemptionContainer/GiftCardRedemptionContainer';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root({store}) {
    return (
        <Provider store={store}>
            <GiftCardRedemptionContainer/>
        </Provider>
    );
}

export default hot(module)(Root);
